<template>
  <div class="photos-upload">
    <photo-upload></photo-upload>
  </div>
</template>

<script>
import PhotoUpload from '@/components/Photo-Upload'
export default {
  name: 'photos-upload',
  components: {
    PhotoUpload
  },
  created () {
    this.$emit('setDate', '')
  }
}
</script>

<style scoped>
  .photos-upload {
    padding-top: 10px;
  }
</style>
